<template>
  <section class="tip-section">
    <div class="flex items-center gap-1.5 tip-section__header">
      <img src="../../assets/publish.svg" />
      <h4>Publish your site</h4>
    </div>

    <div class="banner-info">
      Customize and publish your site so your customers can shop your store.
      <button @click="goToSettings">Settings</button>
    </div>
    <button class="close-btn" @click="closeBanner">
      <img src="../../assets/close-publish.svg" />
    </button>
  </section>
</template>

<script>
export default {
  methods: {
    goToSettings() {
      this.$router.push('/e-commerce/setting')
    },
    closeBanner() {
      this.$emit('closeBanner')
    }
  }
}
</script>

<style scoped lang="scss">
.tip-section {
  position: relative;
  background-color: #dfdad2;
  padding: 1.5rem;
  border-radius: 12px;

  .tip-section__header {
    img {
      width: 20px;
    }

    h4 {
      font-size: 0.875rem;
      font-weight: 800;
    }
  }

  .banner-info {
    font-size: 0.813rem;
    text-align: left;
    line-height: 1.5rem;
    margin-top: 0.8rem;
    color: #232220;

    button {
      color: #232220;
      font-size: 0.913rem;
      font-weight: 700;
      text-decoration: underline;
    }
  }

  .close-btn {
    position: absolute;
    right: 18px;
    top: 12px;
  }
}
</style>
